module.exports = __webpack_public_path__ + "img/index02.11ee726e.jpg";